var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpCenterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.531,
    height: 29.531,
    viewBox: "0 0 29.531 29.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M14.766,0A14.766,14.766,0,1,0,29.531,14.766,14.757,14.757,0,0,0,14.766,0Zm-.437,21.677a1.5,1.5,0,0,1,0-2.993,1.5,1.5,0,0,1,0,2.993Zm2.216-7.561a2.441,2.441,0,0,0-1.088,2.429c0,.369-.194.8-1.147.8-.8,0-1.069-.292-1.069-1.3a3.558,3.558,0,0,1,1.3-2.954c.641-.544,1.73-1.147,1.73-2.2,0-.894-.777-1.322-1.749-1.322-1.982,0-1.555,1.5-2.6,1.5a1.115,1.115,0,0,1-1.166-1.108c0-1.05,1.205-2.6,3.829-2.6,2.488,0,4.14,1.38,4.14,3.207S17.069,13.708,16.544,14.116Z",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterIcon);
export default __webpack_public_path__ + "static/media/help_center_icon.256beaf1f921e6c130f5ca1a77add926.svg";
export { ForwardRef as ReactComponent };